import {Navigate, Outlet} from 'react-router-dom';
import { useSelector} from 'react-redux';
import AdminLayout from './AdminLayout';

const PrivateRoute = () => {
    const {isLoggedIn} = useSelector(state => state.auth);
  return isLoggedIn ? (
    <AdminLayout>
      {' '}
      <Outlet />{' '}
    </AdminLayout>
  ) : (
    <Navigate to="/login" />
  );
};
export default PrivateRoute;
